<template>
    <div class="modal-container comment-reporting-modal-container" v-if="isOpen">
        <div class="comment-reporting-modal modal">
            <div class="bg" @click="closeReportingModal()">
                <div class="modal" @click.stop="">
                    <div class="modal-inner">
                        <div class="inner-bg" role="presentation"></div>
                        <div class="kids-bg" role="presentation"><div class="frame"></div></div>

                        <button type="button" class="btn btn-close btn-close-modal"
                                @click="closeReportingModal"
                        ><span class="sr-only">Fermer</span></button>

                        <form class="inner" @submit.prevent="submitReportReason" v-if="!isSubmitted">
                            <div class="btn-report-comment-inverted"></div>
                            <h1 class="modal-title" v-html="copydeck?.whyAreReporting?.fr ?? 'hmmmmmmm' "></h1>
                            <div class="reasons">
                                <div v-for="reason in copydeck.reportReasons" class="radio-group" :key="reason.id">
                                    <input type="radio" :id=" 'report_reason_' + reason.id "
                                           :value="reason.id"
                                           @change="adjustReasonId(reason.id)"
                                           name="report-reasons"/>
                                    <label :for=" 'report_reason_' + reason.id" class="radio-label">{{
                                            reason.reason
                                        }}</label>
                                </div>
                            </div>
                            <input type="hidden" name="report-comment-id" :value="commentReportId" ref="commentIdField">
                            <div class="submit-container">
                                <button type="submit" class="btn link-show-all"
                                        v-html="copydeck.btnReport.fr"
                                        :disabled="commentReportReasonId < 1"
                                        ref="btnReportSubmit"
                                ></button>
                            </div>
                        </form>


                        <div class="success-message" v-if="isSubmitted && !reportExisted">
                            <h1 class="modal-title"
                                v-html="copydeck?.commentReportedSuccessTitle?.fr ?? 'copydeck?.commentReportedSuccessTitle?.fr' "></h1>
                            <div class="content"
                                 v-html="copydeck?.commentReportedSuccessContent?.fr ?? 'copydeck?.commentReportedSuccessContent?.fr' "></div>

                        </div>

                        <div class="success-message" v-if="isSubmitted && reportExisted">
                            <h1 class="modal-title"
                                v-html="copydeck?.commentWasReportedSuccessTitle?.fr ?? 'copydeck?.commentWasReportedSuccessTitle?.fr' "></h1>

                            <div class="content"
                                 v-html="copydeck?.commentWasReported?.fr ?? 'copydeck?.commentWasReported?.fr' "></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script setup>

import { useStore }                      from 'vuex';
import { computed, ref,  }                      from 'vue';
import { freezeBodyScroll, unfreezeBodyScroll, getCsrfCookie, isUserLoggedIn } from '../../Utils';
import axios                                               from 'axios';


let store    = useStore();
let copydeck = computed( () => store.state.copydeck );

let postId                = computed( () => store.getters.mainContentId ?? 0 );
let isOpen                = computed( () => store.getters.isReportModalOpen ?? false );
let commentReportId       = computed( () => store.getters.reportCurrentCommentId ?? 0 );
let commentReportReasonId = computed( () => store.getters.reportReasonId ?? 0 );


let commentIdField  = ref( null );
let isSubmitted     = ref( false );
let reportExisted   = ref( false );
let btnReportSubmit = ref( null );

function closeReportingModal ()
{

    store.commit( 'changeReportReasonId', 0 );


    if ( isSubmitted )
    {
        isSubmitted.value = false;
    }

    unfreezeBodyScroll();
    store.commit( 'closeReportingModal' );

}

function openReportingModal ()
{

    // can be done through
    // const event = new Event('openLoginModal');
    // window.dispatchEvent(event);
    freezeBodyScroll();

    store.commit( 'openReportingModal' );
}


async function submitReportReason ()
{

    // console.log( 'Gonna try to to report. ', store.getters.reportCommentId, store.getters.reportReasonId );

    const btn = ref( btnReportSubmit ).value;

    btn.disabled = true;
    btn.classList.add( 'ajaxing' );

    try
    {

        const response = await axios.post( '/endpoints/report-comment',
            {
                commentId : store.getters.reportCommentId,
                reasonId  : store.getters.reportReasonId,
            },
            {} );

        console.log( 'submitReportReason:success', response );

        isSubmitted.value = true;
        reportExisted.value = response.data.exist ?? false;

    }
    catch (error)
    {

        console.error( '[ReportComment.vue:submitReportReason] There was an error', error );
        if ( error.response )
        {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            ////console.log('submitLogin', error.response.data);
            ////console.log('submitLogin', error.response.status);
            ////console.log('submitLogin', error.response.headers);

            // this.formErrors = error.response.data.errors;
            // window.scrollTo( {
            //     top      : this.getElementOffset( '.form-section-register' ).top,
            //     left     : 0,
            //     behavior : 'smooth',
            // } );

        } else if ( error.request )
        {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            ////console.log(error.request);
        } else
        {
            // Something happened in setting up the request that triggered an Error
            ////console.log('Error', error.message);
        }
    }


    btn.disabled = false;
    btn.classList.remove( 'ajaxing' );
}


function adjustReasonId ( reasonId )
{

    // console.log( 'Adjusting reporting module to send reason ID # ' + reasonId );
    store.commit( 'changeReportReasonId', reasonId );
}
</script>

<style scoped>

</style>
